<template>
<div style="position:relative; overflow-x:hidden;"
     v-if="$parent.currentUser.adm_acc">
<div style="height:0.9rem;color:red;font-size:0.8rem;">
  {{ fstatus }}
</div>
<b-row style="border-bottom: 1px solid black; padding-bottom: 1px;">
  <b-col>
    <b-form-radio-group v-model="roomshow" name="room-radio"
       style="font-size:0.9rem;">
      <span style="display:inline-block;margin-right:0.3rem;">
        Which Rooms?
      </span>
      <b-form-radio value="all">
        All
      </b-form-radio>
      <b-form-radio value="nonempty">
        Non-empty
      </b-form-radio>
      <b-button class="refbtn float-right"
        variant="danger"
        size="sm"
        @click="roomsRefresh()"
      >
       Refresh All
    </b-button>
    </b-form-radio-group>
  </b-col>
</b-row>
<b-row v-if="rooms && rooms.length">
  <b-col>
     <div v-for="room in rooms">
        <div class="roomheader">
           <span> {{ room.dn }} </span>
           <span>
             <b-button class="refbtn float-right"
               variant="danger"
               size="sm"
               @click="roomRefresh(room.key)"
             >
                Refresh
             </b-button>
           </span>
        </div>
        <div class="usertable">
              <b-table
                 striped
                 show-empty
                 stacked="sm"
                 :fields="userFields"
                 :items="room.users"
                 small
                 empty-text="No users."
               >
               </b-table>
        </div>
     </div>
  </b-col>
</b-row>
<b-row v-if="!rooms || !rooms.length">
  <b-col style="text-align:center;font-weight:bold;">
     <span v-if="roomshow == 'all'">
        There are no rooms to check.
     </span>
     <span v-if="roomshow == 'nonempty'">
        All rooms are empty.
     </span>
  </b-col>
</b-row>
</div>
</template>

<script>

//import InputSub from "../components/InputSub";

export default {
  name: "SurveyAcc",
  components: {
  },
  watch: {
    roomshow: {
      handler(newVal, oldVal) {
         this.update_all();
      }
    }
  },
  data() {
    return  {
      roomshow: "nonempty",
      fstatus: "",
      rhash: {},
      userFields: [
        { key: "dname", label: "Name" },
        { key: "status", label: "Status" },
        { key: "lastjoined", label: "Joined" },
      ],
      roomFields: [
        { key: "dn", label: "Room" },
        { key: "users", label: "" },
      ],
      rooms: [],
    };
  },
  computed: {
  },
  created() {
    let vue = this;
  },
  mounted() {
    let vue = this;
    let opt = {};
    if (!vue.$parent.currentUser.adm_acc) { return; }
    $("body").css("background-color","white");
    window.wss_open(vx, {
      acc: vx.acc,
      uid: vx.user.id,
      routes_id: "updateevent",
      routes: {
        auth_me: function() {
          vue.populate_rooms();
        },
      }
    });
  },
  beforeDestroy() {
    let vue = this;
  },
  methods: {
    populate_rooms: function(start_key) {
      let vue = this;
      vue.fstatus = "Fetching rooms...";
      window.wss_send_cb(vx, "survey_acc", {
        cfg: {
          cmd:"list_rooms",
          start_key: start_key,
        }
      }, function (msg) {
        if (!msg.data.ok) { return; }
        msg.data.rooms.forEach(function(r) {
          if (!vue.rhash[r.name]) {
            vue.rhash[r.name] = {
              dn:r.name.split("/")[1],
              uhash: {},
            };
          }
        });
        if (msg.data.last_key) {
          vue.populate_rooms(msg.data.last_key);
        } else {
          /* Done */
          vue.fstatus = "";
          //vue.rhash["uploadvue/houseofpancakes"] =
          //  {dn:"houseofpancakes",uhash:[]};
          //console.log("rhash",vue.rhash);
          let update_list = Object.keys(vue.rhash);
          vue.populate_users(update_list);
        }
      });
    },
    populate_users: function(update_list, start_key) {
      let vue = this;
      let room = update_list[0];
      vue.fstatus = `Fetching users ${room}...`;
      window.wss_send_cb(vx, "survey_acc", {
        cfg: {
          cmd:"list_users",
          room: room,
          start_key: start_key,
        }
      }, function (msg) {
        if (msg.data.ok) {
          msg.data.users.forEach(function(u) {
             vue.rhash[room].uhash[u.uid] = u;
          });
          if (msg.data.last_key &&
              Object.keys(vue.rhash[room].uhash).length < 50) {
            vue.populate_users(update_list,msg.data.last_key);
            return;
          }
        }
        /* Done With Room */
        update_list.shift();
        if (update_list.length) {
           vue.populate_users(update_list);
        } else {
           /* Completely Done */
           vue.fstatus = "";
           //console.log("rhash",vue.rhash);
           vue.update_all();
        }
      });
    },
    resetRoom(key) {
      let vue = this;
      let rh = vue.rhash[key];
      if (rh) {
        Object.keys(rh.uhash).forEach(function(uid) {
           /* Will get overwritten if still present */
           let uh = rh.uhash[uid];
           if (!uh.hasleft) {
              uh.hasleft = true;
           } else {
             delete rh.uhash[uid];
           }
        });
      }      
    },
    roomsRefresh: function(key) {
      let vue = this;
      let update_list = Object.keys(vue.rhash);
      update_list.forEach(function(room) {
        vue.resetRoom(room);
      });
      vue.populate_users(update_list);
    },
    roomRefresh: function(key) {
      let vue = this;
      vue.resetRoom(key);
      vue.populate_users([ key ]);
    },
    update_all: function() {
      let vue = this;
      let rooms = [];
      Object.keys(vue.rhash).forEach(function(r) {
        let rh = vue.rhash[r];
        let room = {};
        room.key = r;
        room.dn = "@"+rh.dn;
        room.users = [];
        Object.keys(rh.uhash).forEach(function(u) {
          let uh = rh.uhash[u];
          let user = {};
          user.dname = uh.dname || "";
          if (uh.uid && uh.uid.match(/^gu\-/)) {
             user.dname += " guest";
          }
          user.status = "?";
          if (uh.hasleft) {
            user._rowVariant = "danger";
            user.status = "Has Left";
          } else if (uh.offline) {
            user.status = "offline";
          } else if (!uh.kind) {
            user.status = "watching";
          } else if (uh.kind == "aud") {
            user.status = "audience";
          } else if (uh.kind == "mod") {
            user.status = "voice-only";
          } else if (uh.kind == "inl") {
            user.status = "hand-raised";
          } else if (uh.kind == "prs") {
            user.status = "presenter";
          }
          if (uh.kat) {
            let dms = Math.max(0,(Date.now() - uh.kat))/1000;
            if (dms < 5) {
              user.lastjoined = "now";
            } else if (dms < 60) {
              dms = Math.trunc(dms);
              user.lastjoined = `${dms}s`;
            } else if (dms < 3600) {
              dms = Math.trunc(dms/60);
              user.lastjoined = `${dms}min`;
            } else {
              dms = Math.trunc(dms/3600);
              user.lastjoined = `${dms}hr`;
            }
          } else {
            user.lastjoined = "-";
          }
          room.users.push(user);
        });
        if (vue.roomshow == "all" || room.users.length) {
          rooms.push(room);
        }
      });
      vue.rooms = rooms;
    },
  },
}
</script>

<style lang="scss" scoped>

.roomheader {
  padding: 0.1rem 0;
  margin-top: 1rem;
  font-size: 1rem; 
  font-weight: bold;
  color: black;
  background-color: #c0c0d0;
  border-top: 2px solid black
}

.usertable {
  font-size: 0.9rem;
}

.refbtn {
  padding: 0 1rem;
  font-size: 0.9rem;
}

</style>